// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectDocumentClassification = function (x) {
    return x;
};
var tsBridgeProjectDocumentCl = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectDocumentClassification")("__brandProjectDocumentClassification"));
    }
};
var writeProjectDocumentClassification = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectDocumentClassification = Data_Show.showString;
var readProjectDocumentClassification = Simple_JSON.readString;
var ordProjectDocumentClassification = Data_Ord.ordString;
var newtypeProjectDocumentClassification = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectDocumentClassification = ProjectDocumentClassification;
var eqProjectDocumentClassification = Data_Eq.eqString;
export {
    ProjectDocumentClassification,
    makeProjectDocumentClassification,
    unwrap,
    newtypeProjectDocumentClassification,
    eqProjectDocumentClassification,
    ordProjectDocumentClassification,
    showProjectDocumentClassification,
    readProjectDocumentClassification,
    writeProjectDocumentClassification,
    tsBridgeProjectDocumentCl
};
//# sourceMappingURL=index.js.map
